export const colors = {
  focusShadow: 'rgba(208, 46, 46, 1)',
  buttonBackground: '#3470FF',
  buttonHover: '#0B44CD',
  loader: 'rgba(188, 26, 26, 0.2)',
  textParams: 'rgba(18, 20, 23, 0.50)',
  textLink: '#3470FF',
  textDescription: '#121417',
  textButton: '#FFF',
  textDetails: '#363535;',
  textFilter: '#8A8A89',
  gradientStart: 'rgba(18, 20, 23, 0.5) 2.5%',
  gradientMiddle: ' rgba(18, 20, 23, 0) 41.07%',
  gradientEnd: 'rgba(211, 211, 211, 0.5)',
  iconEmpty: '#FFF',
  iconFilled: '#3470FF',
  iconClose: '#121417',
  overlayColor: 'rgba(18, 20, 23, 0.50)',
  mainBackground: '#FFF',
  inputBackground: '#f7f7fb',
  inputBorder: 'rgba(138, 138, 137, 0.2)',
  detailsBackground: '#f9f9f9',
};
